import type { SVGProps } from 'react'
const SvgSyInfoSolid = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M10.9 17.6h2.2v-6.7h-2.2zM12 8.7c.3 0 .6-.1.8-.3s.3-.5.3-.8-.1-.6-.3-.8-.5-.3-.8-.3-.6.1-.8.3-.3.5-.3.8.1.6.3.8.5.3.8.3m0 14.4c-1.5 0-3-.3-4.3-.9s-2.5-1.4-3.5-2.4-1.8-2.2-2.4-3.5S.9 13.5.9 12s.3-3 .9-4.3 1.4-2.5 2.4-3.5 2.2-1.8 3.5-2.4S10.5.9 12 .9s3 .3 4.3.9 2.5 1.4 3.5 2.4 1.8 2.2 2.4 3.5.9 2.8.9 4.3-.3 3-.9 4.3-1.4 2.5-2.4 3.5-2.2 1.8-3.5 2.4-2.8.9-4.3.9" />
	</svg>
)
export default SvgSyInfoSolid
